module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "comment_input",
    class: {
      noBorder: _vm.noBorder
    }
  }, [_c('user-tag', {
    staticClass: "commenter",
    attrs: {
      "user": _vm.currentUser,
      "showAvatar": "",
      "hideTick": "",
      "hideName": "",
      "width": "42",
      "height": "42"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.commentText),
      expression: "commentText",
      modifiers: {
        "trim": true
      }
    }],
    class: {
      roundInput: _vm.roundInput
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": (_vm.commentText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.commentText = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (_vm.commentText.length) ? _c('img', {
    staticClass: "ml-3 addComment-cta",
    attrs: {
      "src": require("../../static/images/ic_send_dark.svg")
    },
    on: {
      "click": function($event) {
        _vm.addComment()
      }
    }
  }) : _c('img', {
    staticClass: "ml-3 addComment-cta",
    attrs: {
      "src": require("../../static/images/ic_send.svg")
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9ed37f6c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/commentInput.vue
// module id = 1823
// module chunks = 180